
export const categories = [
  { id: "all", name: "All" },
  { id: "sale", name: "Buy" },
  { id: "rent", name: "Rent" },
  { id: "lease", name: "Lease" },
];
